import { store } from '../../store'
import { plainToClass } from 'class-transformer'
import { ListVideosDTO } from '../../dto/videos'
import { validate } from 'class-validator'

export const listVideos = async ( page: number = 1 ) => {

    let body, response

    const { keyword, order } = store.getState().videos

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/2.0.0/cms/videos?page=${ page }&order_by=${ order.by }&order_direction=${ order.direction }${ keyword !== `` ? `&keyword=${ keyword }` : `` }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'GET'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_VIDEOS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'LIST_VIDEOS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'LIST_VIDEOS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( ListVideosDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_VIDEOS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'LIST_VIDEOS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'LIST_VIDEOS_OK', videos: body.videos, pagination: body.pagination, highlightedVideo: body.highlightedVideo } )

}